import { render, staticRenderFns } from "./VueDataTableTooltipText.vue?vue&type=template&id=f640a26e&scoped=true"
import script from "./VueDataTableTooltipText.vue?vue&type=script&lang=js"
export * from "./VueDataTableTooltipText.vue?vue&type=script&lang=js"
import style0 from "./VueDataTableTooltipText.vue?vue&type=style&index=0&id=f640a26e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f640a26e",
  null
  
)

export default component.exports